/* DFVmobile V2: fetch collection-context HTML only after a device is selected.
   No global catalog duplication. No trust assumptions about completeness. */
(() => {
  const mount=document.querySelector('[data-dfv-quickshop]');
  const finder=document.querySelector('.dfv-finder--home dfv-device-search');
  if(!mount || !finder)return;
  const content=mount.querySelector('[data-dfv-dynamic]');
  const title=mount.querySelector('[data-dfv-chosen-model]');
  const status=mount.querySelector('[data-dfv-loading]');
  const error=mount.querySelector('[data-dfv-error]');
  const allLink=mount.querySelector('[data-dfv-all-link]');
  const tabs=mount.querySelector('[data-dfv-family-tabs]');
  const buttons=[...tabs.querySelectorAll('[data-dfv-filter]')];
  let request=null;
  let sequence=0;
  const language=(document.documentElement.lang||'en').slice(0,2);
  const lang={
    es:{busy:'Añadiendo...',added:'Añadido al carrito',view:'Ver carrito',error:'No se pudo añadir al carrito. Inténtalo de nuevo.'},
    en:{busy:'Adding...',added:'Added to cart',view:'View cart',error:'Could not add to cart. Please try again.'},
    de:{busy:'Wird hinzugefügt...',added:'Zum Warenkorb hinzugefügt',view:'Warenkorb ansehen',error:'Hinzufügen fehlgeschlagen. Bitte erneut versuchen.'},
    fr:{busy:'Ajout en cours...',added:'Ajouté au panier',view:'Voir le panier',error:'Ajout impossible. Veuillez réessayer.'},
    it:{busy:'Aggiunta in corso...',added:'Aggiunto al carrello',view:'Vedi carrello',error:'Impossibile aggiungere al carrello.'},
    ja:{busy:'追加中...',added:'カートに追加しました',view:'カートを見る',error:'追加できませんでした。もう一度お試しください。'}
  }[language]||{busy:'Adding...',added:'Added to cart',view:'View cart',error:'Could not add to cart.'};
  const track=(event,params)=>{
    if(Array.isArray(window.dataLayer))window.dataLayer.push({event,...params});
  };
  const setActive=(family) => {
    const cards=[...content.querySelectorAll('[data-dfv-family]')];
    cards.forEach(card=>card.hidden=family!=='all'&&card.dataset.dfvFamily!==family);
    buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.dfvFilter===family)));
  };
  const setTabs=()=>{
    const families=new Set([...content.querySelectorAll('[data-dfv-family]')].map(el=>el.dataset.dfvFamily));
    buttons.forEach(button=>{button.hidden=button.dataset.dfvFilter!=='all'&&!families.has(button.dataset.dfvFilter);});
    tabs.hidden=families.size===0;
    setActive('all');
  };
  // Keep the visible model name separate from the technical handle shown for ambiguous devices.
  // Match + and "Plus" as the same device variant label, without changing URLs or compatibility.
  const normalizedModel=(value)=>String(value||'').normalize('NFKC').toLowerCase()
    .replace(/\+/g,' plus ').replace(/[^\p{L}\p{N}]+/gu,' ').replace(/\s+/g,' ').trim();
  const suggestionName=(link)=>(
    link.querySelector('.dfv-finder__suggestion-copy > span')?.textContent?.trim()
    || link.querySelector('span:nth-child(2)')?.textContent?.trim()
    || link.textContent.trim()
  );
  const readPreview=()=>new URL(window.location.href).searchParams.get('preview_theme_id');
  async function choose(url,name,{scroll=true}={}){
    if(window.DFVCro)url=window.DFVCro.withTypeUrl(url,window.DFVCro.currentType(),location.origin);
    sequence+=1;const current=sequence;
    if(request)request.abort();
    request=new AbortController();
    title.textContent=name;
    mount.hidden=false;
    mount.closest('.dfv-home-assortment')?.classList.add('dfv-has-device');
    mount.setAttribute('aria-busy','true');
    status.hidden=false;
    error.hidden=true;
    tabs.hidden=true;
    content.replaceChildren();
    allLink.href=url;
    const endpoint=new URL(url,location.origin);
    endpoint.searchParams.set('section_id','dfv-device-quickbuy');
    const preview=readPreview();
    if(preview)endpoint.searchParams.set('preview_theme_id',preview);
    if(scroll)mount.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
    try{
      const res=await fetch(endpoint.toString(),{signal:request.signal,headers:{'Accept':'text/html'}});
      if(!res.ok)throw new Error('Section status '+res.status);
      const html=await res.text();
      if(current!==sequence)return;
      const documentFragment=new DOMParser().parseFromString(html,'text/html');
      const fragment=documentFragment.querySelector('[data-dfv-fragment]');
      if(!fragment)throw new Error('Collection section unavailable');
      content.replaceChildren(document.importNode(fragment,true));
      setTabs();
    }catch(e){
      if(current!==sequence || e.name==='AbortError')return;
      error.hidden=false;
      console.warn('DFVmobile: quickshop fallback to collection',e);
    }finally{
      if(current===sequence){mount.setAttribute('aria-busy','false');status.hidden=true;}
    }
  }
  // Pressing the Find button on an exact visible model selects it on HOME too.
  finder.addEventListener('submit',event=>{
    const input=finder.querySelector('input[type=search]');
    const value=normalizedModel(input?.value||'');
    const matching=[...finder.querySelectorAll('a.dfv-finder__suggestion--model')]
      .filter(a=>normalizedModel(suggestionName(a))===value);
    if(matching.length===1){
      event.preventDefault();
      event.stopImmediatePropagation();
      matching[0].click();
    }
  },true);
  finder.addEventListener('click',ev=>{
    const link=ev.target.closest('a.dfv-finder__suggestion--model');
    if(!link||ev.defaultPrevented||ev.metaKey||ev.ctrlKey||ev.shiftKey||ev.altKey||ev.button!==0)return;
    const url=new URL(link.href,location.origin);
    if(url.origin!==location.origin || !url.pathname.includes('/collections/'))return;
    ev.preventDefault();
    const name=suggestionName(link);
    choose(url.pathname,name);
    // Keep visible search state aligned with the exact chosen variant.
    const input=finder.querySelector('input[type=search]');
    if(input)input.value=name;
    finder.dismiss?.();
    track('dfv_model_selected',{device:name,collection:url.pathname});
    try{sessionStorage.setItem('dfv-selected-device-v2',JSON.stringify({name,url:url.pathname}));}catch(e){}
  });
  mount.querySelector('[data-dfv-change]').addEventListener('click',()=>{
    sequence+=1;request?.abort();
    mount.hidden=true;
    mount.closest('.dfv-home-assortment')?.classList.remove('dfv-has-device');
    const input=finder.querySelector('input[type=search]');
    input?.focus();
    input?.select();
  });
  // Use Shopify's locale-aware Ajax Cart API; checkout and inventory remain authoritative.
  mount.addEventListener('submit',async event=>{
    const form=event.target.closest('form.dfv-quickshop__cart-form');
    if(!form)return;
    event.preventDefault();
    const button=form.querySelector('button[type="submit"]');
    if(!button||button.disabled)return;
    const variant=new FormData(form).get('id');
    if(!variant)return;
    button.disabled=true;
    const before=button.textContent;
    button.textContent=lang.busy;
    let feedback=form.parentElement.querySelector('[data-dfv-cart-feedback]');
    if(!feedback){
      feedback=document.createElement('p');
      feedback.dataset.dfvCartFeedback='';
      feedback.setAttribute('role','status');
      feedback.className='dfv-quickshop__feedback';
      form.insertAdjacentElement('afterend',feedback);
    }
    feedback.replaceChildren();
    try{
      const rootBase=window.Shopify?.routes?.root || finder.dataset.root || '/';
      const root=rootBase.endsWith('/')?rootBase:rootBase+'/';
      const response=await fetch(root+'cart/add.js',{
        method:'POST',
        credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:Number(variant),quantity:1})
      });
      const data=await response.json();
      if(!response.ok)throw Error(data.description||data.message||'Cart error');
      try {
        const res=await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store'});
        if(!res.ok)throw Error('Cart count unavailable');
        const count=Number((await res.json()).item_count);
        if(!Number.isSafeInteger(count)||count<0)throw Error('Bad cart count');
        const icon=document.getElementById('cart-icon-bubble');
        if(icon){
          let bubble=icon.querySelector('.cart-count-bubble');
          if(!count)bubble?.remove();
          else{
            if(!bubble){bubble=document.createElement('div');bubble.className='cart-count-bubble';icon.append(bubble);}
            bubble.replaceChildren();
            if(count<100){const n=document.createElement('span');n.setAttribute('aria-hidden','true');n.textContent=String(count);bubble.append(n);}
            const label=document.createElement('span');label.className='visually-hidden';label.textContent=({es:'Artículos en el carrito: ',en:'Cart items: ',de:'Artikel im Warenkorb: ',fr:'Articles dans le panier : ',it:'Articoli nel carrello: ',ja:'カート内の商品数: '}[language]||'Cart items: ')+count;bubble.append(label);
          }
        }
      }catch(e){console.warn('DFVmobile cart badge refresh unavailable',e);}
      const success=document.createElement('span');
      success.textContent=lang.added+' · ';
      const link=document.createElement('a');
      link.href=root+'cart';link.textContent=lang.view;
      feedback.append(success,link);
      track('dfv_quick_add',{device:title.textContent,variant_id:String(variant)});
    }catch(error){
      feedback.textContent=lang.error;
      console.warn('DFVmobile quick add:',error);
    }finally{button.disabled=false;button.textContent=before;}
  });

  buttons.forEach(btn=>btn.addEventListener('click',()=>{setActive(btn.dataset.dfvFilter);track('dfv_family_filter',{family:btn.dataset.dfvFilter,device:title.textContent});}));
  // Remember model as a shortcut without background requests affecting initial LCP.
  try{
    const saved=JSON.parse(sessionStorage.getItem('dfv-selected-device-v2')||'null');
    // A model saved in one market must never redirect a visitor into another locale.
    const activeRoot=(finder.dataset.root||'/').replace(/\/$/,'');
    const savedPath=typeof saved?.url==='string'?saved.url:'';
    const collectionMarker=savedPath.indexOf('/collections/');
    const correctLocale=collectionMarker>=0 && savedPath.startsWith('/') && !savedPath.startsWith('//')
      && savedPath.slice(0,collectionMarker)===activeRoot;
    if(saved?.name && correctLocale){
      const shortcut=document.createElement('button');
      shortcut.type='button';shortcut.className='dfv-quickshop__last';
      shortcut.textContent=saved.name+' ↗';
      shortcut.addEventListener('click',()=>choose(saved.url,saved.name));
      finder.append(shortcut);
    }
  }catch(e){}
})();